module.exports = __webpack_public_path__ + "static/img/ic_two.913d459.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/ic_two.png
// module id = 429
// module chunks = 1